import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, IconButton, Popover, MenuItem, Avatar, ListItemIcon } from '@mui/material';
import Iconify from '../../../components/iconify';
import { removeToken, getToken, storeUsername, getUsername, storeEmail, getEmail, storeAdmin, getAdmin } from '../../../services/LocalStorageService';
import version from '../../../_mock/account';
import { useUserProfileQuery } from '../../../services/dvagent';

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const [profilePicture, setProfilePicture] = useState(null);
  const { data, isSuccess } = useUserProfileQuery(getToken());

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLogout = () => {
    removeToken();
  };

  useEffect(() => {
    if (data && isSuccess) {
      setProfilePicture("https://cdn-icons-png.flaticon.com/512/5087/5087579.png");
      storeUsername(`${data.data[0].first_name} ${data.data[0].last_name}`);
      storeEmail(data.data[0].email);
      storeAdmin(data.data[0].is_superuser);
    }
  }, [data, isSuccess]);

  const handleMenuItemClick = () => {
    // Prevent the menu from closing when a menu item is clicked
    setOpen(null);
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={profilePicture} alt="photoURL" />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 250,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {getUsername()}{getAdmin() === "true" && (<span style={{ color: 'text.secondary', fontSize: 12, fontStyle: 'italic' }}>&nbsp;(Admin)</span>)}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: 12 }} noWrap>
            {getEmail()}
          </Typography>
        </Box>


        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem to="/cloud/user-profile" sx={{ m: 1 }} component={RouterLink} onClick={handleMenuItemClick}>
          <ListItemIcon>
            <Iconify icon='teenyicons:user-solid' />
          </ListItemIcon>
          Profile
        </MenuItem>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem to="/cloud/change-password" sx={{ m: 1 }} component={RouterLink} onClick={handleMenuItemClick}>
          <ListItemIcon>
            <Iconify icon='teenyicons:password-solid' />
          </ListItemIcon>
          Change Password
        </MenuItem>
        <Divider sx={{ borderStyle: 'dashed' }} />

        {/* {getAdmin() === "true" && (
          <>
            <MenuItem to="/cloud/administration" sx={{ m: 1 }} component={RouterLink} onClick={handleMenuItemClick}>
              <ListItemIcon>
                <Iconify icon='uiw:setting' />
              </ListItemIcon>
              Administration
            </MenuItem>
            <Divider sx={{ borderStyle: 'dashed' }} />
          </>
        )} */}

        <MenuItem to="/" onClick={handleLogout} sx={{ m: 1 }} component={RouterLink}>
          <ListItemIcon>
            <Iconify color="#CD1818" icon='eva:log-out-outline' />
          </ListItemIcon>
          Logout
        </MenuItem>
        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleMenuItemClick} sx={{ m: 1, fontStyle: "italic", background:"#A8A196", color:"#FFF" }}>
          <ListItemIcon>
            <Iconify color="#FFF" icon='mingcute:version-fill' />
          </ListItemIcon>
          DV Agent  ({version.version})
        </MenuItem>
      </Popover>
    </>
  );
}
